import React, { useEffect, useState } from 'react';
import { theme } from '../constants';

import { hooks } from '../hooks';
import { custom } from '../custom';
import { product } from '../product';
import { Card, Row, Col, Button, Typography, Tag } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

type Props = {
  item: any;
  isLast?: boolean;
  version?: number;
};

export const ProductCard: React.FC<Props> = ({ isLast, item, version = 1 }) => {
  const navigate = hooks.useAppNavigate();

  // Home > BestSeller item //
  if (version === 1) {
    return (
      <div
        onClick={() => {
          navigate('/product', { state: { item } });
        }}
        className="w-full max-w-md bg-white rounded shadow overflow-hidden flex transition-all duration-300 transform hover:shadow-xl hover:-translate-y-1"
        style={{
          height: 172, // ارتفاع ثابت کارت
        }}
      >
                      {/* دکمه علاقه‌مندی - بالا سمت راست */}
                      <product.ProductInWishlist
            item={item}
            style={{
              position: 'absolute',
              right: 5,
              top: 5,
              padding: 5,
              zIndex: 1000,
            }}
          />
        {/* بخش تصویر */}
        <custom.ImageBackground
          imageUrl={item.image}
          style={{
            width: 150, // عرض ثابت
            height: '80%',
            borderRadius: '12px 0 0 12px',
            position: 'relative', // مهم! باعث میشه absolute داخل این بخش کار کنه
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            alignSelf:'anchor-center',
          }}
        >
          <></>
        </custom.ImageBackground>

    
          {/* دکمه سبد خرید یا برچسب ناموجود - پایین سمت راست */}
          {item.is_available ? (
            <product.ProductInCart
              item={item}
              style={{
                position: 'absolute',
                left: 15,
                bottom: 15,
              }}
            />
          ) : (
            <Tag
              style={{
                position: 'absolute',
                left: 5,
                bottom: 15,
              }}
              className="rounded-full w-fit"
            >
              ناموجود
            </Tag>
          )}
        {/* بخش جزئیات */}
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '10px 12px',
            textAlign: 'right',
          }}
        >
          <h6
            style={{
              marginTop: 15,
              marginBottom: 6,
              fontSize: 14,
              color: theme.colors.textColor,
              ...theme.fonts.Mulish_400Regular,
              fontWeight: 400,
            }}
          >
            {item.title}
          </h6>
      <>
              <div className="flex flex-wrap items-baseline gap-x-1 gap-y-1">
                <span className="text-gray-900 text-sm" style={{ fontSize: 10 }}>
                    برند:                 
                </span>
                <span className="text-red-600 text-xl font-semibold" style={{ fontSize: 12 }}>
                {item.brand?.title || "بدون برند"}
                </span>
        
              </div>
            </>
          <product.ProductPrice item={item} />
        </div>
      </div>
    );
    
  }

  // Shop Item
  if (version === 2) {
    return (
      <div
        onClick={() => {
          navigate('/product', { state: { item } });
        }}
        className="w-full max-w-md bg-white rounded shadow overflow-hidden transition-all duration-300 transform hover:shadow-xl hover:-translate-y-1"
      >
        <custom.ImageBackground
          imageUrl={item.image}
          style={{
            width: '100%',
            height: 170,
            borderRadius: 12,
            marginBottom: 6,
            position: 'relative',
            backgroundSize: 'contain',
          }}
        >
          <product.ProductInWishlist
            item={item}
            style={{
              position: 'absolute',
              margin: 10,
              left: 0,
              top: 0,
              zIndex: 3,
            }}
          />
          {item.is_available ? (
            <product.ProductInCart
              item={item}
              style={{
                position: 'absolute',
                margin: 10,
                left: 0,
                top: 46 - 10,
              }}
            />
          ) : (
            <Tag style={{
              position: 'absolute',
              margin: 10,
              left: 0,
              top: 46 - 10,
            }} color='volcano'>ناموجود</Tag>
          )}
        </custom.ImageBackground>
        <div
          style={{
            flexDirection: 'column',
            textAlign: 'right',
          }}
          className={"p-6"}
        >
          <h6
            style={{
              marginTop: 0,
              marginBottom: 6,
              fontSize: 14,
              color: theme.colors.textColor,
              ...theme.fonts.Mulish_400Regular,
              fontWeight: 400,
            }}
          >
            {item.title}
          </h6>
          <product.ProductPrice item={item} />
          <button className="w-full lg:w-auto bg-indigo-600 text-white px-6 py-3 rounded font-semibold text-base shadow-lg shadow-indigo-100 transition-all duration-200 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3z" />
              <path d="M16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
            </svg>
            Add to Cart
          </button>
        </div>
      </div>
    );
  }

  // Featured Item
  if (version === 3) {
    const blockWidth = 138;

    return (
      <div
        style={{
          width: blockWidth,
          cursor: 'pointer',
          marginRight: isLast ? 20 : 14,
          borderRadius: 12,
        }}
        onClick={() => {
          navigate('/product', { state: { item } });
        }}
        className="w-full max-w-md bg-white rounded shadow overflow-hidden transition-all duration-300 transform hover:shadow-xl hover:-translate-y-1"
      >
        <custom.ImageBackground
          imageUrl={item.image}
          style={{
            width: blockWidth,
            height: 170,
            borderRadius: 12,
            marginBottom: 6,
            position: 'relative',
            backgroundSize: 'contain',
            backgroundColor: theme.colors.imageBackground,
          }}
        >
          <product.ProductInWishlist
            item={item}
            style={{
              position: 'absolute',
              padding: 10,
              left: 0,
            }}
          />
          <product.ProductInCart
            item={item}
            style={{
              position: 'absolute',
              left: 0,
              top: 40,
              padding: 10,
            }}
          />
        </custom.ImageBackground>
        <div
          style={{
            width: blockWidth,
            flexDirection: 'column',
            textAlign: 'right',
          }}
        >
          <div style={{ marginBottom: 2 }}>
            <product.ProductRating rating={item.rating} />
          </div>
          <h6
            style={{
              fontSize: 14,
              color: theme.colors.textColor,
              ...theme.fonts.Mulish_400Regular,
              fontWeight: 400,
              marginTop: 0,
              marginBottom: 3,
              lineHeight: 1.5,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {item.title}
          </h6>
          <product.ProductPrice item={item} />
        </div>
      </div>
    );
  }

  if (version === 4) {
    const blockWidth = 138;

    return (
      <Card style={{ marginBottom: 16 }} bodyStyle={{ padding: 16 }}>
        <Row align='middle' gutter={16}>
          {/* عکس محصول */}
          <Col xs={24} sm={6}>
            <img
              src={item.image}
              alt={item.title}
              style={{
                width: '100%',
                height: 150,
                objectFit: 'cover',
                borderRadius: 8,
              }}
            />
          </Col>

          {/* اطلاعات محصول */}
          <Col xs={24} sm={12}>
            <Title level={4}>{item.title}</Title>
            <Paragraph ellipsis={{ rows: 2 }}>{item.description}</Paragraph>
            <Text strong>قیمت: {item.price} تومان</Text>
          </Col>

          {/* عملیات‌ها */}
          <Col xs={24} sm={6} style={{ textAlign: 'center' }}>
            <Button
              type='primary'
              icon={<ShoppingCartOutlined />}
              disabled={!item.is_available}
              size='large'
              style={{ marginTop: 8 }}
            >
              افزودن به سبد خرید
            </Button>
          </Col>
        </Row>
      </Card>
    );
  }

  if (version == 5) {
    return (
      <div
        onClick={() => {
          navigate('/product', { state: { item } });
        }}
        className="w-full max-w-md bg-white rounded shadow overflow-hidden transition-all duration-300 transform hover:shadow-xl hover:-translate-y-1"
      >
        <custom.ImageBackground
          imageUrl={item.image}
          style={{
            width: '100%',
            height: 170,
            borderRadius: 12,
            marginBottom: 6,
            position: 'relative',
            backgroundSize: 'contain',
          }}
        >
          <product.ProductInWishlist
            item={item}
            style={{
              position: 'fixed',     // یا 'absolute' در صورت نیاز داخل container خاص
              left: 0,
              top: 0,
              padding: 5,
              zIndex: 1000,          // مطمئن شو روی عناصر دیگه می‌افته
            }}
          />
          {item.is_available ? (
            <product.ProductInCart
              item={item}
              style={{
                position: 'fixed',
                margin: 10,
                left: 0,
                bottom: 46 - 10,
              }}
            />
          ) : (
            <Tag style={{
              position: 'fixed',
              margin: 10,
              left: 0,
              bottom: 46 - 10,
            }}
            className="rounded-full w-fit"
            >ناموجود</Tag>
          )}
        </custom.ImageBackground>
        <div
          style={{
            flexDirection: 'column',
            textAlign: 'right',
          }}
          className='pl-2 pt-2 pr-2'
        >
          <h6
            style={{
              marginTop: 0,
              marginBottom: 6,
              fontSize: 14,
              color: theme.colors.textColor,
              ...theme.fonts.Mulish_400Regular,
              fontWeight: 400,
            }}
          >
            {item.title}
          </h6>
          <product.ProductPrice item={item} />
        </div>
      </div>
    );
  }
  return null;
};
